import type { ISession } from "@mne-authentication/api";
import * as CurrentuserApi from "@mne-authentication/api/currentuser";

import type { permissionCheckerUtil } from "@mnemonic/argus-menu";
import type { IEnvConfig } from "@mnemonic/pure-utils/ArgusUtils";

import HttpError from "./Errors/HttpError";

export default async function initializeSession(target: IEnvConfig): Promise<ISession | null> {
  const { domain, apiUrl } = target;
  const query = await CurrentuserApi.fetchSession({ domain }, { apiUrl });

  if (query.response.ok) {
    return query.json;
  } else if (query.response.status === 401) {
    return null;
  }

  throw new HttpError(query.response.statusText, query);
}

/**
 *
 * Util to convert the legacy ISession to a typescript compatible type for the menu.
 * This can eventually be removed when the session has been implemented using core-redux
 *
 * @param session
 * @returns TSessionDataAdapter
 */

export const toSessionAdapter = (session: ISession): Parameters<typeof permissionCheckerUtil>[0] => {
  return {
    info: session?.info,
    user: session?.user
      ? {
          id: session?.user?.id,
          name: session?.user?.name,
          domain: session?.user?.domain,
          customer: session?.user?.customer,
          properties: session?.user?.properties,
          flags: session?.user?.flags,
        }
      : null,
    functions: session?.functions?.map((f) => f),
  };
};
